<h1 mat-dialog-title>Bestellvorschau</h1>

<mat-dialog-content>
    <div class="pdf-blatt" *ngFor="let blatt of blaetter">
        <div class="pdf-titel">Bestellung</div>
        <p *ngIf="blatt.lieferant" class="pdf-an">{{ blatt.lieferant }}</p>
        <table>
            <thead>
                <tr>
                    <th class="pos">Pos.</th>
                    <th>Artikel</th>
                    <th *ngIf="hatInhalt(blatt)">Inhalt je Einheit</th>
                    <th class="menge">Bestellmenge</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let zeile of blatt.positionen; let i = index">
                    <td class="pos">{{ i + 1 }}</td>
                    <td>{{ zeile.artikel }}</td>
                    <td *ngIf="hatInhalt(blatt)">{{ zeile.inhalt }}</td>
                    <td class="menge">{{ zeile.menge }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close>Schließen</button>
</mat-dialog-actions>
